import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
export function WhatsAppConnection() {
  const [isConnected, setIsConnected] = useState(false);
  const navigate = useNavigate();
  const handleConnect = () => {
    if (isConnected) {
      navigate('/dashboard');
    } else {
      setIsConnected(true);
    }
  };
  return <div className="min-h-screen bg-[#F5F5F5] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-2xl font-semibold text-[#212121] text-center mb-3">
            Connect your WhatsApp
          </h1>
          <p className="text-sm text-gray-600 text-center mb-8">
            Scan the QR code below to link your WhatsApp Business account.
          </p>
          <div className="relative mb-6">
            <div className="aspect-square bg-gray-100 rounded-2xl shadow-md flex items-center justify-center border-2 border-gray-200">
              {!isConnected ? <div className="w-48 h-48 bg-white rounded-xl flex items-center justify-center">
                  <div className="grid grid-cols-8 gap-1">
                    {Array.from({
                  length: 64
                }).map((_, i) => <div key={i} className="w-3 h-3 bg-[#212121] rounded-sm" style={{
                  opacity: Math.random() > 0.5 ? 1 : 0
                }} />)}
                  </div>
                </div> : <div className="flex flex-col items-center justify-center">
                  <CheckCircleIcon className="w-24 h-24 text-[#5B8E87] mb-4" />
                  <p className="text-lg font-semibold text-[#5B8E87]">
                    Connected Successfully
                  </p>
                </div>}
            </div>
          </div>
          <p className="text-xs text-gray-500 text-center mb-8">
            Use your phone's WhatsApp app to scan this code.
          </p>
          <button onClick={handleConnect} className="w-full bg-[#5B8E87] text-white font-semibold py-4 rounded-xl shadow-md hover:bg-[#4F7A74] transition-colors text-base">
            {isConnected ? 'Connected, Continue →' : 'Simulate Connection'}
          </button>
        </div>
      </div>
    </div>;
}